import { Component, Prop, PropSync, Ref, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Logger } from 'fsts';
import rfd, { ReportFilterData } from '@/shared/model/smallPayloadModels/reportFilterData';
import { SaveList } from '@/shared/model/saveList';
import reportDown, { ReportDownload } from '@/shared/model/reportDownload';
import { CONST } from '@/shared/utils/Constants';

const logger = new Logger('document-comment-dialog');
const articleModule = namespace('article');
const saveListModule = namespace('saveList');
const reportDownloadModule = namespace('reportDownload');

@Component({
  name: 'report-dialog-zrmitglieder',
  components: {},
})
export default class ReportDialogZRMitglieder extends Vue {
  @Ref('observer-report-dialog-form')
  private observerReportDialogForm!: any;


  @articleModule.Action('getArticlesListZRMitglieder')
  private actionGetListZRMitglieder!: any;

  @articleModule.Action('getArticlesMitgliedZipReport')
  private actionGetArticlesMitgliedZipReport!: any;

  @articleModule.Action('getArticlesSuppliersFiltered')
  private actionGetArticlesSuppliers!: any;
  @articleModule.Getter('getArticlesSuppliers')
  private getArticlesSuppliers!: any;


  @reportDownloadModule.Action('updateReportDownload')
  private actionUpdateReportDownload!: any;

  @Prop({ default: false })
  private dialog!: boolean;

  @Prop()
  private listModel!: any;
  @Prop()
  private selectedValues!: any;
  @Prop()
  private hasSelectionBefore!: any;

  private model!: any;

  private isPdf = true;
  private isOneFile = false;
  private isOutputID = false;
  private isMitglied = false;
  private quantityCopies = '1';
  private zeroRecordsResponse = false;
  private isLoadingReport = false;

  mitglieds:any = {};
  

  async created() {
    // await this.getSaveListData();
    this.transformMitgliedDataForTable();
  }


  private async transformMitgliedDataForTable() {
    console.log('listModel :>> ', this.listModel);

    this.mitglieds = this.listModel;
    // .map((value:any, index:number) => ({
    //   // Assign the raw value to a key, for example 'number'
    //   mitglied: value,
    //   // You can also add an index if needed for a row number
    //   index: index + 1,
    // }));

    if (this.hasSelectionBefore) {
      // let selectedValues = this.mitglieds.filter((x:any) => {
      //  return this.selectedValues.includes(x.mitglied);
      // });
      // console.log('selectedValues :>> ', selectedValues);

      this.selected.push(...this.selectedValues);
      console.log('this.selected :>> ', this.selected);
    }
    // const payload: ReportFilterData = rfd.defaultData();

    // this.preparePayload(payload);

    // await this.actionGetArticlesSuppliers(payload)
    //   .then((result: any) => {
    //     this.suppliersBackend = result;
    //     this.populateSuppliersTable();
    //   })
    //   .catch((err: any) => {
    //     logger.error(err);
    //   });
  }

  populateSuppliersTable() {
    // this.suppliersBackend.forEach((el: any) => {
    //   this.mitglieds.push({
    //     name: `${el.lieferantenNummer} ${el.lieferantName}`,
    //     count: el.count,
    //     number: el.lieferantenNummer, // send to backend to filter `Suppliers` for report
    //     status: 'aktiv',
    //     updateAt: el.lastUpdated, // new Date().toISOString(),
    //   });
    // });
  }

  search = '';
  singleSelect = false;
  selected:any = [];


  get headers() {
    let headers: {
      text: string | any;
      value: string;
      sortable?: boolean;
      width?: string;
    }[] = [
      { text: this.$t('mitglied_column'), value: 'ZRNummer' },
      { text: this.$t('name_column'), value: 'Name' },
      // { text: this.$t('count'), value: 'count' },
      // { text: this.$t('status'), value: 'status' },
      // { text: this.$t('update_at'), value: 'updateAt' },
    ];
    return headers;
  }

  async clickSave() {
    const result = await this.observerReportDialogForm.validate();

    console.log(
      '------------------------------------------------------------  ===>>> this.quantityCopies  ',
      this.quantityCopies,
      '  this.isMitglied ',
      this.isMitglied,
      '  ',
      this.quantityCopies.length,
      '  this.selected?.length   ',
      this.selected?.length
    );

    const payload: ReportFilterData = rfd.defaultData();
    // use `any` to avoid `System.ArgumentNullException: Value cannot be null. (Parameter 'request')` error
    if (result) {
      const selectedMitglieds = this.selected;//.map((x:any)=> x.mitglied);
      this.$emit('return:mitglied', selectedMitglieds);
      this.clickClose();
    }
  }


  

  private async getMitgliedZipReport(payload: ReportFilterData) {
    await this.actionGetArticlesMitgliedZipReport(payload).catch((err: any) => {
      logger.error(err);
    });
  }


  filterInput(value: string) {
    console.log('value :>> ', value);
    // Only allow digits, a decimal point, and the negative sign
    const filteredValue = value.replace(/[^0-9.-]/g, '');
    console.log('filtered :>> ', filteredValue);
    this.quantityCopies = filteredValue;
  }

  sanitizeInput(value: string) {
    // Allow only digits (this will strip out anything except 0-9)
    let sanitizedValue = value.replace(/[^0-9]/g, ''); // Keep only numbers
    if (sanitizedValue === '') sanitizedValue = '1'; // Default to 0 if empty

    // Convert back to number and check max value
    let numericValue = parseInt(sanitizedValue, 10);
    if (numericValue > 50) {
      numericValue = 50; // Max value set to 50
    }

    // Update the value after sanitization and limit
    this.quantityCopies = numericValue.toString();
  }

  handleKeyDown(event: KeyboardEvent) {
    const key = event.key;
    const currentValue = this.quantityCopies;

    // Allow backspace, delete, arrow keys, etc.
    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter'];

    // Allow digits 0-9
    const isDigit = /^[0-9]$/.test(key);

    // If it's not a digit or an allowed key, prevent the input
    if (!isDigit && !allowedKeys.includes(key)) {
      event.preventDefault();
    }

    // If the value is 50 or more, prevent entering any more digits
    if (parseInt(currentValue, 10) >= 50 && isDigit) {
      event.preventDefault();
    }
  }

  clickClose() {
    this.$emit('click:close');
  }

  changeReport(value: any) {
    console.log('-----------------changeReport-------------------------------------------  ===>>>  value ', value);
    if (value == false) {
      this.isOutputID = false;
      this.isMitglied = false;
      this.quantityCopies = '1';
    }
  }

  changeSelectMitglied(value: any) {
    console.log(
      '-----------------changeSelectMitglied-------------------------------------------  ===>>>  value ',
      value
    );
    if (value == false) {
      this.quantityCopies = '1';
    }
  }

  changeSelectOutputID(value: any) {
    console.log(
      '-----------------changeSelectOutputID-------------------------------------------  ===>>>  value ',
      value,
      '  isMitglied    ',
      this.isMitglied
    );
    if (value == false) {
      this.quantityCopies = '1';
      if (this.isMitglied) this.isMitglied = false;
    }
    console.log(
      '-----------------changeSelectOutputID-------------------------------------------  ===>>>  value ',
      value,
      '  isMitglied    ',
      this.isMitglied
    );
  }

  dialogZRMitgliederReport = {
    show: false,
    model: {},
    OnClose: () => {
      this.dialogZRMitgliederReport.show = false;
    },
  };

  private showZRMitgliederDialog() {
    console.log('-----------------showZRMitgliederDialog-------------------------------------------  ===>>>   ');
    this.dialogZRMitgliederReport.show = true;
    //this.dialogZRMitgliederReport.model = item;
  }
}